import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TextEditProvider } from './components/text/TextEdit';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AppShell from './components/shell/AppShell';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AuthCallback from './pages/AuthCallback';
import PathBDashboard from './pages/PathBDashboard';
import DeskPage from './pages/DeskPage';
import HomePage from './pages/HomePage';
import ArtifactDashboard from './pages/ArtifactDashboard';
import ProjectPage from './pages/ProjectPage';
import SettingsPage from './pages/SettingsPage';
import CorpusAdminPage from './pages/CorpusAdminPage';
import TenantAdminPage from './pages/TenantAdminPage';
import UiTextPage from './pages/UiTextPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

export default function App() {
  return (
    <AuthProvider>
      {/* 067: edit-mode state, so the toggle in the header and every <T> on the page agree. */}
      <TextEditProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/" element={<ProtectedRoute><AppShell><HomePage /></AppShell></ProtectedRoute>} />
          {/* The projects list is gone - no "project" in the UI. The route survives only as a
              redirect so an old bookmark lands somewhere real. */}
          <Route path="/projects" element={<Navigate to="/ideas" replace />} />
          <Route path="/desk" element={<ProtectedRoute><AppShell><DeskPage /></AppShell></ProtectedRoute>} />
          <Route path="/pathb" element={<ProtectedRoute><AppShell><PathBDashboard /></AppShell></ProtectedRoute>} />          <Route path="/ideas" element={<ProtectedRoute><AppShell><ArtifactDashboard kind="ideas" /></AppShell></ProtectedRoute>} />
          <Route path="/markets" element={<ProtectedRoute><AppShell><ArtifactDashboard kind="markets" /></AppShell></ProtectedRoute>} />
          <Route path="/packs" element={<ProtectedRoute><AppShell><ArtifactDashboard kind="packs" /></AppShell></ProtectedRoute>} />
          <Route path="/project/:id" element={<ProtectedRoute><AppShell><ProjectPage /></AppShell></ProtectedRoute>} />
          <Route path="/project/:id/:stage" element={<ProtectedRoute><AppShell><ProjectPage /></AppShell></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><AppShell><SettingsPage /></AppShell></ProtectedRoute>} />
          <Route path="/settings/billing" element={<ProtectedRoute><AppShell><SettingsPage /></AppShell></ProtectedRoute>} />
          <Route path="/settings/llm" element={<ProtectedRoute><AppShell><SettingsPage /></AppShell></ProtectedRoute>} />
          <Route path="/admin/corpus" element={<ProtectedRoute><AppShell><CorpusAdminPage /></AppShell></ProtectedRoute>} />
          {/* Five routes, one component: it picks its section from the path, as SettingsPage does. */}
          <Route path="/admin/tenants" element={<ProtectedRoute><AppShell><TenantAdminPage /></AppShell></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AppShell><TenantAdminPage /></AppShell></ProtectedRoute>} />
          <Route path="/admin/models" element={<ProtectedRoute><AppShell><TenantAdminPage /></AppShell></ProtectedRoute>} />
          <Route path="/admin/credits" element={<ProtectedRoute><AppShell><TenantAdminPage /></AppShell></ProtectedRoute>} />
          <Route path="/admin/text" element={<ProtectedRoute><AppShell><UiTextPage /></AppShell></ProtectedRoute>} />
          <Route path="/admin/dimensions" element={<ProtectedRoute><AppShell><TenantAdminPage /></AppShell></ProtectedRoute>} />          {/* /admin has no page of its own — send admins to the god panel (which itself bounces
              non-admins to the dashboard). Any unknown route redirects to the dashboard instead
              of rendering a silent blank page. */}
          <Route path="/admin" element={<Navigate to="/admin/tenants" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      </TextEditProvider>
    </AuthProvider>
  );
}
